import { fb, validators } from '../../lib/form';

export function getStyleMatchModel(data) {
    const model = fb.group({
        unsubscribed: [true, [], { label: `Subscribe to our newsletter`, type: 'checkbox' }],
        email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
        name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }]
    });
    return model;
}